export type ScopedDataAccess =
    | PerJobAccess
    | PerGTAccess
    | PerTaskAccess
    | PerCollabTaskAccess

export type DataAccess = OwnerAccess | ScopedDataAccess

/**
 * User has access to the data because they are the owner of it.
 */
export interface OwnerAccess {
    type: "owner"
}

/**
 * User has access to the data because they have read-access to the job using that data.
 */
export interface PerJobAccess {
    type: "perJob"
    jobID: string
}

/**
 * User has access to the data because they have read-access to the ground truth using that data.
 */
export interface PerGTAccess {
    type: "perGT"
    baselineID: string
}

/**
 * User has access to the data because they have read-access to the ground truth using that data.
 */
export interface PerTaskAccess {
    type: "perTask"
    taskID: string
}

export interface PerCollabTaskAccess {
    type: "perCollabTask"
    collabTaskId: string
}

const ownerDataAccess = { type: "owner" } as const

export const DataAccess = {
    owner: ownerDataAccess,
    perJob: (jobID: string) => ({ type: "perJob", jobID } as const),
    perGT: (baselineID: string) => ({ type: "perGT", baselineID } as const),
    perTask: (taskID: string) => ({ type: "perTask", taskID } as const),
    perCollabTask: (collabTaskId: string) =>
        ({ type: "perCollabTask", collabTaskId } as const)
}
